export const LOCATION_CONSENT_GRANTED = 'granted';
export const LOCATION_CONSENT_REVOKED = 'revoked';
export const PERMISSION_UNKNOWN = 'unknown';

export function normalizeLocationConsent(value) {
  return [LOCATION_CONSENT_GRANTED, LOCATION_CONSENT_REVOKED].includes(value) ? value : '';
}

export function normalizePermissionState(value) {
  return ['prompt', 'granted', 'denied'].includes(value) ? value : PERMISSION_UNKNOWN;
}

export function shouldAutoStartLocation({ userId, consent, permissionState, permissionsSupported }) {
  if (!(Number(userId) > 0) || normalizeLocationConsent(consent) !== LOCATION_CONSENT_GRANTED) return false;
  const permission = normalizePermissionState(permissionState);
  return permission === 'granted' || (permissionsSupported === false && permission === PERMISSION_UNKNOWN);
}

export function locationActionMode({ consent, permissionState, status, secureContext = true, geolocationSupported = true }) {
  if (!secureContext) return 'https_required';
  if (!geolocationSupported) return 'unsupported';
  if (normalizePermissionState(permissionState) === 'denied' || status === 'denied') return 'browser_denied';
  if (['active', 'inaccurate', 'requesting'].includes(status)) return 'hidden';
  if (normalizeLocationConsent(consent) !== LOCATION_CONSENT_GRANTED) return 'request_consent';
  if (normalizePermissionState(permissionState) === 'prompt') return 'renew_permission';
  if (['timeout', 'unavailable'].includes(status)) return 'retry';
  return 'hidden';
}

export function isValidBrowserCoordinates(position) {
  const latitude = Number(position?.coords?.latitude);
  const longitude = Number(position?.coords?.longitude);
  return Number.isFinite(latitude)
    && Number.isFinite(longitude)
    && latitude >= -90
    && latitude <= 90
    && longitude >= -180
    && longitude <= 180;
}
